import React, { useRef, useEffect, useState, useCallback } from 'react';

// -- Shared styles ------------------------------------------------
const styles = `
  @import url('https://fonts.googleapis.com/css2?family=Space+Mono:ital,wght@0,400;0,700;1,400&family=Crimson+Pro:ital,wght@0,300;0,400;1,300&display=swap');

  .st-root {
    background: #04060f;
    color: #c8d8ee;
    font-family: 'Space Mono', monospace;
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }
  .st-header {
    padding: 14px 32px 10px;
    border-bottom: 1px solid rgba(91,200,250,0.18);
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-shrink: 0;
  }
  .st-header-left { display: flex; align-items: baseline; gap: 18px; }
  .st-header h1 {
    font-family: 'Crimson Pro', serif;
    font-weight: 300;
    font-style: italic;
    font-size: 1.6rem;
    color: #e8f4ff;
    margin: 0;
  }
  .st-header .subtitle {
    font-size: 0.58rem;
    color: #4a6080;
    letter-spacing: 0.12em;
    text-transform: uppercase;
  }
  .st-page-tabs { display: flex; gap: 4px; }
  .st-page-tab {
    font-family: 'Space Mono', monospace;
    font-size: 0.6rem;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    padding: 7px 18px;
    border: 1px solid rgba(91,200,250,0.22);
    border-radius: 3px;
    background: none;
    color: #4a6080;
    cursor: pointer;
    transition: all 0.18s;
  }
  .st-page-tab.active { background: rgba(91,200,250,0.1); border-color: #5bc8fa; color: #5bc8fa; }
  .st-page-tab:hover:not(.active) { border-color: rgba(91,200,250,0.4); color: #8aaccc; }

  .st-layout { display: grid; grid-template-columns: 1fr 290px; flex: 1; overflow: hidden; }
  .st-canvas-area { position: relative; overflow: hidden; }
  .st-canvas-area canvas { width: 100%; height: 100%; display: block; }
  .st-sidebar {
    border-left: 1px solid rgba(91,200,250,0.18);
    padding: 16px;
    display: flex;
    flex-direction: column;
    gap: 16px;
    overflow-y: auto;
    background: rgba(8,18,35,0.92);
  }
  .st-panel-title { font-size: 0.58rem; letter-spacing: 0.15em; text-transform: uppercase; color: #5bc8fa; margin-bottom: 10px; }
  .st-key-item { display: flex; align-items: center; gap: 10px; margin-bottom: 7px; font-size: 0.65rem; color: #8aaccc; line-height: 1.4; }
  .st-swatch { width: 26px; height: 3px; flex-shrink: 0; border-radius: 2px; }
  .st-swatch-dashed { width: 26px; height: 2px; flex-shrink: 0; background: repeating-linear-gradient(to right, #f78e7e 0, #f78e7e 5px, transparent 5px, transparent 9px); }
  .st-tabs { display: flex; border-bottom: 1px solid rgba(91,200,250,0.18); }
  .st-tab { font-family: 'Space Mono', monospace; font-size: 0.55rem; letter-spacing: 0.08em; text-transform: uppercase; color: #4a6080; padding: 7px 12px; cursor: pointer; border: none; background: none; border-bottom: 2px solid transparent; transition: all 0.2s; }
  .st-tab.active { color: #5bc8fa; border-bottom-color: #5bc8fa; }
  .st-tab-content { padding-top: 14px; }
  .st-view-toggle { display: flex; gap: 6px; flex-wrap: wrap; }
  .st-view-btn { font-family: 'Space Mono', monospace; font-size: 0.55rem; letter-spacing: 0.06em; text-transform: uppercase; padding: 5px 10px; border: 1px solid rgba(91,200,250,0.18); border-radius: 3px; background: none; color: #4a6080; cursor: pointer; transition: all 0.2s; }
  .st-view-btn.active, .st-view-btn:hover { border-color: #5bc8fa; color: #5bc8fa; background: rgba(91,200,250,0.07); }
  .st-slider-row { display: flex; flex-direction: column; gap: 4px; margin-bottom: 12px; }
  .st-slider-label { display: flex; justify-content: space-between; font-size: 0.58rem; color: #5a7a9a; text-transform: uppercase; letter-spacing: 0.08em; }
  .st-slider-label span:last-child { color: #5bc8fa; }
  .st-slider { width: 100%; -webkit-appearance: none; height: 2px; background: rgba(91,200,250,0.18); border-radius: 2px; outline: none; }
  .st-slider::-webkit-slider-thumb { -webkit-appearance: none; width: 11px; height: 11px; border-radius: 50%; background: #5bc8fa; cursor: pointer; box-shadow: 0 0 8px rgba(91,200,250,0.5); }
  .st-concept { font-family: 'Crimson Pro', serif; font-size: 0.88rem; font-weight: 300; line-height: 1.6; color: #a8c0d8; border-left: 2px solid rgba(91,200,250,0.18); padding-left: 10px; margin-bottom: 10px; }
  .st-concept em { color: #5bc8fa; font-style: italic; }
  .st-formula { font-family: 'Crimson Pro', serif; font-style: italic; font-size: 1rem; color: #c8e0ff; text-align: center; padding: 8px; background: rgba(91,200,250,0.05); border-radius: 4px; margin: 6px 0; }
  .st-insight { font-size: 0.63rem; color: #6a8aaa; line-height: 1.6; margin-top: 4px; margin-bottom: 8px; }
  .st-compare-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 8px; margin-top: 8px; }
  .st-nc-newton { padding: 9px; border-radius: 4px; font-size: 0.58rem; line-height: 1.5; background: rgba(200,100,80,0.1); border: 1px solid rgba(200,100,80,0.2); color: #c88070; }
  .st-nc-einstein { padding: 9px; border-radius: 4px; font-size: 0.58rem; line-height: 1.5; background: rgba(91,200,250,0.07); border: 1px solid rgba(91,200,250,0.15); color: #7ac0e0; }
  .st-nc-newton strong, .st-nc-einstein strong { display: block; margin-bottom: 4px; letter-spacing: 0.08em; text-transform: uppercase; font-size: 0.52rem; }

  /* Guide page */
  .st-guide { flex: 1; overflow-y: auto; padding: 36px 48px 60px; background: #04060f; }
  .st-guide h2 { font-family: 'Crimson Pro', serif; font-size: 1.25rem; font-weight: 400; color: #5bc8fa; margin-top: 40px; margin-bottom: 12px; border-left: 4px solid #5bc8fa; padding-left: 12px; }
  .st-guide p { font-size: 0.88rem; line-height: 1.8; color: #a8c0d8; margin-bottom: 14px; font-family: 'Crimson Pro', serif; font-weight: 300; }
  .st-guide em { color: #5bc8fa; font-style: italic; }
  .st-guide strong { color: #c8d8ee; font-weight: 700; }
  .st-infobox { background: rgba(91,200,250,0.05); border: 1.5px solid rgba(91,200,250,0.22); border-radius: 6px; padding: 16px 20px; margin: 16px 0; }
  .st-infobox-title { font-weight: 700; font-family: 'Space Mono', monospace; font-size: 0.75rem; color: #5bc8fa; margin-bottom: 10px; letter-spacing: 0.08em; text-transform: uppercase; }
  .st-infobox-item { font-size: 0.82rem; margin: 5px 0; padding-left: 12px; border-left: 2px solid rgba(91,200,250,0.35); color: #a8c0d8; font-family: 'Crimson Pro', serif; font-weight: 300; line-height: 1.6; }
  .st-table { width: 100%; border-collapse: collapse; margin-bottom: 22px; font-size: 0.84rem; }
  .st-th { background: rgba(91,200,250,0.12); color: #5bc8fa; padding: 9px 14px; text-align: left; font-weight: 700; font-size: 0.75rem; letter-spacing: 0.08em; text-transform: uppercase; border-bottom: 1.5px solid rgba(91,200,250,0.3); }
  .st-td-even { padding: 10px 14px; border-bottom: 1px solid rgba(91,200,250,0.08); vertical-align: top; background: rgba(91,200,250,0.03); }
  .st-td-odd  { padding: 10px 14px; border-bottom: 1px solid rgba(91,200,250,0.08); vertical-align: top; background: transparent; }
  .st-td-label { font-weight: 600; color: #7eb8f7; white-space: nowrap; width: 220px; font-family: 'Space Mono', monospace; font-size: 0.75rem; }
  .st-td-content { font-family: 'Crimson Pro', serif; font-weight: 300; font-size: 0.9rem; color: #a8c0d8; line-height: 1.6; white-space: pre-wrap; }
  .st-diagram-wrap { margin: 24px 0; background: rgba(8,18,35,0.7); border: 1px solid rgba(91,200,250,0.14); border-radius: 8px; padding: 20px; }
  .st-diagram-title { font-weight: 700; font-size: 0.8rem; color: #5bc8fa; margin-bottom: 14px; text-align: center; letter-spacing: 0.06em; text-transform: uppercase; font-family: 'Space Mono', monospace; }
  .st-diagram-caption { font-size: 0.78rem; color: #4a6080; text-align: center; margin-top: 10px; font-style: italic; font-family: 'Crimson Pro', serif; }
`;

// -- Guide sub-components -----------------------------------------
function InfoBox({ title, items }) {
  return (
    <div className="st-infobox">
      <div className="st-infobox-title">{title}</div>
      {items.map((item, i) => <div key={i} className="st-infobox-item">{item}</div>)}
    </div>
  );
}

function Table2({ rows }) {
  return (
    <table className="st-table">
      <thead><tr>
        <th className="st-th" style={{ width: 220 }}>Concept</th>
        <th className="st-th">Explanation / Formula</th>
      </tr></thead>
      <tbody>
        {rows.map(([label, content], i) => (
          <tr key={i}>
            <td className={(i % 2 === 0 ? 'st-td-even ' : 'st-td-odd ') + 'st-td-label'}>{label}</td>
            <td className={(i % 2 === 0 ? 'st-td-even ' : 'st-td-odd ') + 'st-td-content'}>{content}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

// -- Guide SVG Diagrams -------------------------------------------
function DiagramNewtonVsEinstein() {
  const W = 860, H = 280;
  return (
    <div className="st-diagram-wrap">
      <div className="st-diagram-title">Newton's Universe vs Einstein's Spacetime</div>
      <svg viewBox={'0 0 ' + W + ' ' + H} style={{ width: '100%', display: 'block' }}>
        <rect x={10} y={10} width={395} height={260} rx={6} fill="rgba(200,100,80,0.05)" stroke="rgba(200,100,80,0.25)" strokeWidth="1"/>
        <text x={207} y={34} textAnchor="middle" fontSize="12" fill="#c88070" fontFamily="'Space Mono',monospace" fontWeight="700" letterSpacing="2">NEWTON</text>
        <line x1={60} y1={220} x2={360} y2={220} stroke="rgba(200,100,80,0.5)" strokeWidth="1.5"/>
        <polygon points="360,216 370,220 360,224" fill="rgba(200,100,80,0.6)"/>
        <text x={375} y={224} fontSize="11" fill="#c88070" fontFamily="'Space Mono',monospace">t</text>
        {[0, 1, 2].map(i => {
          const tx = 80 + i * 90, ty = 100, sz = 60, dep = 18;
          const alpha = 0.3 + i * 0.2;
          const col = 'rgba(200,100,80,' + alpha + ')';
          const colFill = 'rgba(200,100,80,' + (alpha * 0.3) + ')';
          return (
            <g key={i}>
              <rect x={tx} y={ty} width={sz} height={sz} fill={colFill} stroke={col} strokeWidth="1.2"/>
              <polygon points={tx + ',' + ty + ' ' + (tx+dep) + ',' + (ty-dep) + ' ' + (tx+sz+dep) + ',' + (ty-dep) + ' ' + (tx+sz) + ',' + ty} fill={'rgba(200,100,80,' + (alpha*0.15) + ')'} stroke={col} strokeWidth="1.2"/>
              <polygon points={(tx+sz)+','+ty+' '+(tx+sz+dep)+','+(ty-dep)+' '+(tx+sz+dep)+','+(ty+sz-dep)+' '+(tx+sz)+','+(ty+sz)} fill={'rgba(200,100,80,'+(alpha*0.2)+')'} stroke={col} strokeWidth="1.2"/>
              <line x1={tx+sz/2} y1={ty+sz} x2={tx+sz/2} y2={220} stroke={col} strokeWidth="1" strokeDasharray="3,3"/>
              <circle cx={tx+sz/2} cy={220} r={3} fill={col}/>
            </g>
          );
        })}
        <text x={207} y={250} textAnchor="middle" fontSize="10" fill="rgba(200,100,80,0.55)" fontFamily="'Crimson Pro',serif" fontStyle="italic">3D space slides through absolute, universal time</text>

        <rect x={430} y={10} width={420} height={260} rx={6} fill="rgba(91,200,250,0.04)" stroke="rgba(91,200,250,0.2)" strokeWidth="1"/>
        <text x={640} y={34} textAnchor="middle" fontSize="12" fill="#5bc8fa" fontFamily="'Space Mono',monospace" fontWeight="700" letterSpacing="2">EINSTEIN</text>
        <line x1={580} y1={230} x2={580} y2={55} stroke="rgba(91,200,250,0.4)" strokeWidth="1.5"/>
        <polygon points="576,55 580,45 584,55" fill="rgba(91,200,250,0.5)"/>
        <text x={586} y={52} fontSize="10" fill="#5bc8fa" fontFamily="'Space Mono',monospace">ct</text>
        <line x1={580} y1={230} x2={820} y2={230} stroke="rgba(91,200,250,0.3)" strokeWidth="1.5"/>
        <polygon points="820,226 830,230 820,234" fill="rgba(91,200,250,0.4)"/>
        <text x={832} y={234} fontSize="10" fill="#5bc8fa" fontFamily="'Space Mono',monospace">x</text>
        <polygon points="580,230 700,110 460,110" fill="rgba(255,200,50,0.06)"/>
        <line x1={580} y1={230} x2={700} y2={110} stroke="#ffe040" strokeWidth="1.2" strokeDasharray="5,3" opacity="0.7"/>
        <line x1={580} y1={230} x2={460} y2={110} stroke="#ffe040" strokeWidth="1.2" strokeDasharray="5,3" opacity="0.7"/>
        <text x={708} y={106} fontSize="9" fill="#ffe04090" fontFamily="'Space Mono',monospace">light</text>
        <line x1={580} y1={230} x2={580} y2={80} stroke="#7eb8f7" strokeWidth="2.5"/>
        <circle cx={580} cy={80} r={4} fill="#7eb8f7"/>
        <text x={586} y={78} fontSize="9" fill="#7eb8f7" fontFamily="'Space Mono',monospace">A</text>
        <line x1={580} y1={230} x2={650} y2={80} stroke="#f78e7e" strokeWidth="2.5" strokeDasharray="6,3"/>
        <circle cx={650} cy={80} r={4} fill="#f78e7e"/>
        <text x={656} y={78} fontSize="9" fill="#f78e7e" fontFamily="'Space Mono',monospace">B (moving)</text>
        <line x1={500} y1={140} x2={660} y2={140} stroke="rgba(100,200,255,0.4)" strokeWidth="1" strokeDasharray="8,4"/>
        <text x={662} y={143} fontSize="8" fill="rgba(100,200,255,0.5)" fontFamily="'Space Mono',monospace">A now</text>
        <line x1={504} y1={155} x2={680} y2={126} stroke="rgba(255,160,80,0.4)" strokeWidth="1" strokeDasharray="8,4"/>
        <text x={682} y={124} fontSize="8" fill="rgba(255,160,80,0.5)" fontFamily="'Space Mono',monospace">B now</text>
        <circle cx={580} cy={230} r={4} fill="#fff" opacity="0.7"/>
        <text x={640} y={260} textAnchor="middle" fontSize="10" fill="rgba(91,200,250,0.45)" fontFamily="'Crimson Pro',serif" fontStyle="italic">Space and time unified -- worldlines, not cubes</text>
      </svg>
      <div className="st-diagram-caption">Left: Newton -- space is a container, time is universal. Right: Einstein -- spacetime is unified; observers trace worldlines; "now" is different for each.</div>
    </div>
  );
}

function DiagramMinkowski() {
  const W = 860, H = 340;
  const cx = 300, cy = 260;
  return (
    <div className="st-diagram-wrap">
      <div className="st-diagram-title">Minkowski Spacetime Diagram -- Reading a Worldline</div>
      <svg viewBox={'0 0 ' + W + ' ' + H} style={{ width: '100%', display: 'block' }}>
        {[1,2,3,4,5,6].map(i => (
          <g key={i}>
            <line x1={cx-220} y1={cy-i*36} x2={cx+220} y2={cy-i*36} stroke="rgba(91,200,250,0.07)" strokeWidth="1"/>
            <line x1={cx-i*40} y1={cy-210} x2={cx-i*40} y2={cy+50} stroke="rgba(91,200,250,0.07)" strokeWidth="1"/>
            <line x1={cx+i*40} y1={cy-210} x2={cx+i*40} y2={cy+50} stroke="rgba(91,200,250,0.07)" strokeWidth="1"/>
          </g>
        ))}
        <polygon points={(cx)+','+(cy)+' '+(cx+200)+','+(cy-200)+' '+(cx-200)+','+(cy-200)} fill="rgba(255,200,50,0.07)"/>
        <polygon points={(cx)+','+(cy)+' '+(cx+80)+','+(cy+80)+' '+(cx-80)+','+(cy+80)} fill="rgba(255,80,30,0.05)"/>
        <line x1={cx} y1={cy} x2={cx+200} y2={cy-200} stroke="#ffe040" strokeWidth="1.5" strokeDasharray="6,4" opacity="0.7"/>
        <line x1={cx} y1={cy} x2={cx-200} y2={cy-200} stroke="#ffe040" strokeWidth="1.5" strokeDasharray="6,4" opacity="0.7"/>
        <line x1={cx} y1={cy+40} x2={cx} y2={cy-210} stroke="rgba(91,200,250,0.4)" strokeWidth="1.5"/>
        <polygon points={(cx-4)+','+(cy-210)+' '+cx+','+(cy-222)+' '+(cx+4)+','+(cy-210)} fill="rgba(91,200,250,0.5)"/>
        <text x={cx+6} y={cy-212} fontSize="11" fill="#5bc8fa" fontFamily="'Space Mono',monospace">ct</text>
        <line x1={cx-240} y1={cy} x2={cx+240} y2={cy} stroke="rgba(91,200,250,0.3)" strokeWidth="1.5"/>
        <polygon points={(cx+240)+','+(cy-4)+' '+(cx+252)+','+cy+' '+(cx+240)+','+(cy+4)} fill="rgba(91,200,250,0.4)"/>
        <text x={cx+246} y={cy+4} fontSize="11" fill="#5bc8fa" fontFamily="'Space Mono',monospace">x</text>
        <line x1={cx} y1={cy} x2={cx} y2={cy-180} stroke="#7eb8f7" strokeWidth="2.5"/>
        {[36,72,108,144,180].map(y => (
          <line key={y} x1={cx-5} y1={cy-y} x2={cx+5} y2={cy-y} stroke="#7eb8f760" strokeWidth="1.5"/>
        ))}
        <circle cx={cx} cy={cy-180} r={5} fill="#7eb8f7"/>
        <text x={cx+8} y={cy-178} fontSize="10" fill="#7eb8f7" fontFamily="'Space Mono',monospace">A (rest)</text>
        <line x1={cx} y1={cy} x2={cx+110} y2={cy-180} stroke="#f78e7e" strokeWidth="2.5" strokeDasharray="7,4"/>
        {[0.25,0.5,0.75,1.0].map(t => (
          <line key={t} x1={cx+110*t-6} y1={cy-180*t+4} x2={cx+110*t+4} y2={cy-180*t-6} stroke="#f78e7e80" strokeWidth="1.5"/>
        ))}
        <circle cx={cx+110} cy={cy-180} r={5} fill="#f78e7e"/>
        <text x={cx+118} y={cy-178} fontSize="10" fill="#f78e7e" fontFamily="'Space Mono',monospace">B (v=0.5c)</text>
        <line x1={cx-150} y1={cy-108} x2={cx+200} y2={cy-108} stroke="rgba(100,200,255,0.3)" strokeWidth="1" strokeDasharray="10,5"/>
        <text x={cx+202} y={cy-104} fontSize="9" fill="rgba(100,200,255,0.5)" fontFamily="'Space Mono',monospace">A's "now"</text>
        <line x1={cx-80} y1={cy-140} x2={cx+200} y2={cy-68} stroke="rgba(255,160,80,0.35)" strokeWidth="1" strokeDasharray="10,5"/>
        <text x={cx+202} y={cy-65} fontSize="9" fill="rgba(255,160,80,0.55)" fontFamily="'Space Mono',monospace">B's "now"</text>
        <text x={cx+130} y={cy-80} fontSize="10" fill="rgba(255,200,50,0.5)" fontFamily="'Space Mono',monospace">FUTURE</text>
        <text x={cx+60} y={cy+50} fontSize="10" fill="rgba(255,80,30,0.4)" fontFamily="'Space Mono',monospace">PAST</text>
        <text x={cx+150} y={cy+4} fontSize="9" fill="rgba(91,200,250,0.3)" fontFamily="'Space Mono',monospace">ELSEWHERE</text>
        <circle cx={cx} cy={cy} r={4} fill="#fff" opacity="0.7"/>
        <text x={cx+6} y={cy+14} fontSize="9" fill="#ffffff60" fontFamily="'Space Mono',monospace">Origin (0,0)</text>
        <rect x={560} y={20} width={290} height={300} rx={5} fill="rgba(8,18,35,0.8)" stroke="rgba(91,200,250,0.14)"/>
        <text x={705} y={42} textAnchor="middle" fontSize="11" fill="#5bc8fa" fontFamily="'Space Mono',monospace" fontWeight="700">HOW TO READ THIS</text>
        {[
          { y: 58,  col: '#7eb8f7',              title: 'Vertical line = at rest',   body: 'Object stays at x=0.\nTime flows upward.' },
          { y: 108, col: '#f78e7e',              title: 'Tilted line = moving',      body: 'More tilt = faster speed.\n45 deg = speed of light.' },
          { y: 158, col: '#ffe040',              title: '45 deg = light speed',      body: 'Nothing can tilt beyond\n45 deg from vertical.' },
          { y: 208, col: 'rgba(100,200,255,0.6)',title: "Horizontal = 'now' slice",  body: 'Different observers slice\nspacetime differently.' },
          { y: 258, col: 'rgba(255,220,100,0.6)',title: 'Tick marks = proper time',  body: 'Moving clocks have fewer\nticks = time dilation.' },
        ].map(({ y, col, title, body }) => (
          <g key={y}>
            <rect x={568} y={y} width={274} height={44} rx={3} fill="rgba(91,200,250,0.03)" stroke={col} strokeWidth="1"/>
            <text x={578} y={y+14} fontSize="10" fill={col} fontFamily="'Space Mono',monospace" fontWeight="700">{title}</text>
            {body.split('\n').map((line, li) => (
              <text key={li} x={578} y={y+28+li*12} fontSize="9" fill="rgba(168,192,216,0.8)" fontFamily="'Crimson Pro',serif">{line}</text>
            ))}
          </g>
        ))}
      </svg>
      <div className="st-diagram-caption">A spacetime diagram plots position (x) horizontally and time (ct) vertically. Every object traces a worldline. Light always travels at 45 degrees.</div>
    </div>
  );
}

function DiagramLightCone() {
  const W = 860, H = 300;
  const cx = 220, cy = 150;
  return (
    <div className="st-diagram-wrap">
      <div className="st-diagram-title">The Light Cone -- Causal Structure of Spacetime</div>
      <svg viewBox={'0 0 ' + W + ' ' + H} style={{ width: '100%', display: 'block' }}>
        <polygon points={cx+','+cy+' '+(cx-130)+','+(cy-120)+' '+(cx+130)+','+(cy-120)} fill="rgba(255,200,50,0.1)"/>
        <polygon points={cx+','+cy+' '+(cx-130)+','+(cy+120)+' '+(cx+130)+','+(cy+120)} fill="rgba(255,80,30,0.07)"/>
        <line x1={cx} y1={cy} x2={cx-130} y2={cy-120} stroke="#ffe040" strokeWidth="1.8" strokeDasharray="6,4" opacity="0.8"/>
        <line x1={cx} y1={cy} x2={cx+130} y2={cy-120} stroke="#ffe040" strokeWidth="1.8" strokeDasharray="6,4" opacity="0.8"/>
        <line x1={cx} y1={cy} x2={cx-130} y2={cy+120} stroke="#ffe040" strokeWidth="1" strokeDasharray="4,4" opacity="0.5"/>
        <line x1={cx} y1={cy} x2={cx+130} y2={cy+120} stroke="#ffe040" strokeWidth="1" strokeDasharray="4,4" opacity="0.5"/>
        <line x1={cx} y1={cy-130} x2={cx} y2={cy+130} stroke="rgba(91,200,250,0.35)" strokeWidth="1.5"/>
        <line x1={cx-170} y1={cy} x2={cx+170} y2={cy} stroke="rgba(91,200,250,0.25)" strokeWidth="1.5"/>
        <text x={cx+6} y={cy-122} fontSize="10" fill="#5bc8fa" fontFamily="'Space Mono',monospace">ct</text>
        <text x={cx+164} y={cy+4} fontSize="10" fill="#5bc8fa" fontFamily="'Space Mono',monospace">x</text>
        <text x={cx} y={cy-65} textAnchor="middle" fontSize="11" fill="rgba(255,200,50,0.7)" fontFamily="'Space Mono',monospace" fontWeight="700">FUTURE</text>
        <text x={cx-2} y={cy+80} textAnchor="middle" fontSize="11" fill="rgba(255,80,30,0.55)" fontFamily="'Space Mono',monospace" fontWeight="700">PAST</text>
        <text x={cx-150} y={cy-6} fontSize="9" fill="rgba(91,200,250,0.35)" fontFamily="'Space Mono',monospace">ELSEWHERE</text>
        <text x={cx+88} y={cy-6} fontSize="9" fill="rgba(91,200,250,0.35)" fontFamily="'Space Mono',monospace">ELSEWHERE</text>
        <circle cx={cx} cy={cy} r={5} fill="#fff" opacity="0.8"/>
        <text x={cx+8} y={cy+4} fontSize="9" fill="#ffffff80" fontFamily="'Space Mono',monospace">Event P</text>
        <circle cx={cx+40} cy={cy-80} r={4} fill="#7eb8f7"/>
        <line x1={cx} y1={cy} x2={cx+40} y2={cy-80} stroke="#7eb8f760" strokeWidth="1" strokeDasharray="4,3"/>
        <text x={cx+46} y={cy-78} fontSize="9" fill="#7eb8f7" fontFamily="'Space Mono',monospace">Q: causally reachable from P</text>
        <circle cx={cx+160} cy={cy-30} r={4} fill="rgba(91,200,250,0.5)"/>
        <text x={cx+165} y={cy-28} fontSize="9" fill="rgba(91,200,250,0.5)" fontFamily="'Space Mono',monospace">R: no causal link to P</text>
        <rect x={420} y={10} width={430} height={280} rx={5} fill="rgba(8,18,35,0.7)" stroke="rgba(91,200,250,0.12)"/>
        <text x={635} y={34} textAnchor="middle" fontSize="11" fill="#5bc8fa" fontFamily="'Space Mono',monospace" fontWeight="700">CAUSAL ZONES</text>
        {[
          { y: 48,  col: 'rgba(255,200,50,0.7)',  label: 'FUTURE LIGHT CONE',    text: 'All events P can influence.\nNothing gets there faster than light.' },
          { y: 108, col: 'rgba(255,80,30,0.55)',  label: 'PAST LIGHT CONE',      text: 'All events that could have influenced P.\nCauses must lie here.' },
          { y: 168, col: 'rgba(91,200,250,0.45)', label: 'ELSEWHERE (spacelike)',text: 'No causal connection to P.\nObservers disagree on time-ordering.' },
          { y: 228, col: '#ffe040',               label: 'LIGHT CONE SURFACE',   text: 'Only photons travel here at exactly c.\nSets the universal speed limit.' },
        ].map(({ y, col, label, text }) => (
          <g key={y}>
            <rect x={428} y={y} width={414} height={54} rx={3} fill="rgba(91,200,250,0.02)" stroke={col} strokeWidth="1"/>
            <text x={438} y={y+16} fontSize="10" fill={col} fontFamily="'Space Mono',monospace" fontWeight="700">{label}</text>
            {text.split('\n').map((line, li) => (
              <text key={li} x={438} y={y+30+li*14} fontSize="9.5" fill="rgba(168,192,216,0.8)" fontFamily="'Crimson Pro',serif">{line}</text>
            ))}
          </g>
        ))}
      </svg>
      <div className="st-diagram-caption">The light cone defines what can causally influence what. Events inside the future cone can be affected by P; events in "elsewhere" cannot -- for any observer.</div>
    </div>
  );
}

function DiagramTimeDilation() {
  const W = 860, H = 260;
  const ox = 480, oy = 220, gw = 340, gh = 150;
  const gammaPoints = [];
  for (let vi = 0; vi <= 95; vi++) {
    const v = vi / 100;
    const g = 1 / Math.sqrt(1 - v * v);
    gammaPoints.push((ox + (vi / 95) * gw) + ',' + (oy - Math.min((g - 1) / 8, 1) * gh));
  }
  return (
    <div className="st-diagram-wrap">
      <div className="st-diagram-title">Time Dilation -- Lorentz Factor</div>
      <svg viewBox={'0 0 ' + W + ' ' + H} style={{ width: '100%', display: 'block' }}>
        {/* Clock A */}
        <rect x={40} y={30} width={170} height={200} rx={8} fill="rgba(126,184,247,0.06)" stroke="rgba(126,184,247,0.3)" strokeWidth="1.5"/>
        <text x={125} y={52} textAnchor="middle" fontSize="11" fill="#7eb8f7" fontFamily="'Space Mono',monospace" fontWeight="700">OBSERVER A</text>
        <text x={125} y={66} textAnchor="middle" fontSize="9" fill="#4a6080" fontFamily="'Space Mono',monospace">(at rest)</text>
        <circle cx={125} cy={130} r={42} fill="rgba(8,18,35,0.8)" stroke="#7eb8f7" strokeWidth="1.5"/>
        {[0,1,2,3,4,5,6,7,8,9,10,11].map(i => {
          const a = (i / 12) * Math.PI * 2 - Math.PI / 2;
          return <line key={i} x1={125+Math.cos(a)*34} y1={130+Math.sin(a)*34} x2={125+Math.cos(a)*40} y2={130+Math.sin(a)*40} stroke="#7eb8f750" strokeWidth="1.5"/>;
        })}
        <line x1={125} y1={130} x2={125+Math.cos(-Math.PI/2+Math.PI)*26} y2={130+Math.sin(-Math.PI/2+Math.PI)*26} stroke="#7eb8f7" strokeWidth="2.5" strokeLinecap="round"/>
        <line x1={125} y1={130} x2={125+Math.cos(-Math.PI/2+Math.PI*2)*36} y2={130+Math.sin(-Math.PI/2+Math.PI*2)*36} stroke="#7eb8f7" strokeWidth="1.5" strokeLinecap="round"/>
        <text x={125} y={210} textAnchor="middle" fontSize="11" fill="#7eb8f7" fontFamily="'Space Mono',monospace">tau_A = 10.0 yrs</text>
        {/* Clock B */}
        <rect x={250} y={30} width={170} height={200} rx={8} fill="rgba(247,142,126,0.06)" stroke="rgba(247,142,126,0.3)" strokeWidth="1.5"/>
        <text x={335} y={52} textAnchor="middle" fontSize="11" fill="#f78e7e" fontFamily="'Space Mono',monospace" fontWeight="700">OBSERVER B</text>
        <text x={335} y={66} textAnchor="middle" fontSize="9" fill="#4a6080" fontFamily="'Space Mono',monospace">(v = 0.87c)</text>
        <circle cx={335} cy={130} r={42} fill="rgba(8,18,35,0.8)" stroke="#f78e7e" strokeWidth="1.5"/>
        {[0,1,2,3,4,5,6,7,8,9,10,11].map(i => {
          const a = (i / 12) * Math.PI * 2 - Math.PI / 2;
          return <line key={i} x1={335+Math.cos(a)*34} y1={130+Math.sin(a)*34} x2={335+Math.cos(a)*40} y2={130+Math.sin(a)*40} stroke="#f78e7e50" strokeWidth="1.5"/>;
        })}
        <line x1={335} y1={130} x2={335+Math.cos(-Math.PI/2+Math.PI*0.5)*26} y2={130+Math.sin(-Math.PI/2+Math.PI*0.5)*26} stroke="#f78e7e" strokeWidth="2.5" strokeLinecap="round"/>
        <line x1={335} y1={130} x2={335+Math.cos(-Math.PI/2+Math.PI)*36} y2={130+Math.sin(-Math.PI/2+Math.PI)*36} stroke="#f78e7e" strokeWidth="1.5" strokeLinecap="round"/>
        <text x={335} y={210} textAnchor="middle" fontSize="11" fill="#f78e7e" fontFamily="'Space Mono',monospace">tau_B = 5.0 yrs</text>
        <text x={225} y={136} textAnchor="middle" fontSize="22" fill="rgba(91,200,250,0.3)">&#8800;</text>
        {/* Gamma curve */}
        <rect x={455} y={20} width={390} height={220} rx={6} fill="rgba(8,18,35,0.7)" stroke="rgba(91,200,250,0.12)"/>
        <text x={650} y={42} textAnchor="middle" fontSize="11" fill="#5bc8fa" fontFamily="'Space Mono',monospace" fontWeight="700">LORENTZ FACTOR gamma</text>
        <text x={650} y={56} textAnchor="middle" fontSize="9" fill="#4a6080" fontFamily="'Space Mono',monospace">gamma = 1 / sqrt(1 - v^2/c^2)</text>
        <line x1={ox} y1={oy} x2={ox+gw} y2={oy} stroke="rgba(91,200,250,0.25)" strokeWidth="1"/>
        <line x1={ox} y1={oy} x2={ox} y2={oy-gh} stroke="rgba(91,200,250,0.25)" strokeWidth="1"/>
        <polyline points={gammaPoints.join(' ')} fill="none" stroke="#5bc8fa" strokeWidth="2"/>
        {[[0,1,'1.0'],[50,1.155,'1.15'],[70,1.4,'1.40'],[87,2.0,'2.0'],[95,3.2,'~inf']].map(([vi, g, lab]) => {
          const px = ox + (vi / 95) * gw;
          const py = oy - Math.min((g - 1) / 8, 1) * gh;
          return (
            <g key={vi}>
              <circle cx={px} cy={py} r={3} fill="#5bc8fa" opacity="0.7"/>
              <text x={px+4} y={py-4} fontSize="9" fill="#5bc8fa80" fontFamily="'Space Mono',monospace">{vi}%c={lab}</text>
            </g>
          );
        })}
        <text x={ox+gw/2} y={oy+16} textAnchor="middle" fontSize="9" fill="#4a6080" fontFamily="'Space Mono',monospace">velocity (% of c)</text>
      </svg>
      <div className="st-diagram-caption">At 87% of the speed of light, gamma = 2: B ages half as fast as A. Confirmed by particle accelerators and atomic clocks on aircraft to extraordinary precision.</div>
    </div>
  );
}

// -- Guide Page ----------------------------------------------------
function GuidePage() {
  return (
    <div className="st-guide">
      <h2 style={{ marginTop: 0 }}>What Is This Showing?</h2>
      <p>
        This interactive model shows <em>Einstein's view of the universe</em> -- known as Special and General Relativity. It is a direct contrast to Newton's older picture, which treated space as a fixed container and time as a universal clock ticking the same rate for everyone everywhere.
      </p>
      <p>
        Einstein showed in 1905 (Special Relativity) and 1915 (General Relativity) that <em>space and time are not separate things</em> -- they are a single four-dimensional fabric called <strong>spacetime</strong>. Everything that exists traces a path called a <em>worldline</em> through this fabric. Gravity is not a force pulling objects together -- it is <em>spacetime bending</em> around mass, and objects follow the straightest possible paths through the bent geometry.
      </p>

      <DiagramNewtonVsEinstein />

      <InfoBox title="The Four Views in the Interactive Model" items={[
        'Spacetime Diagram (Minkowski) -- shows how two observers moving at different speeds experience different "nows" and age at different rates',
        'Light Cone -- shows the causal structure: what events can influence what, bounded absolutely by the speed of light',
        'Curved Spacetime (GR) -- shows how a massive object bends the spacetime grid, causing orbits and deflecting light',
        'Twin Paradox -- shows concretely why the travelling twin ages less: their worldline is geometrically shorter through spacetime',
      ]} />

      <h2>The Spacetime Diagram</h2>
      <p>
        The most important tool in relativity is the <em>Minkowski diagram</em>. Instead of showing space on a map, it plots one spatial dimension (x) horizontally and time (ct) vertically. Every object traces a line through this diagram -- its <em>worldline</em>. An object at rest draws a vertical line. A moving object draws a tilted line. Light itself travels at exactly 45 degrees.
      </p>
      <p>
        The key insight is that <em>different observers moving at different speeds slice through spacetime differently</em>. What one observer calls "the same moment in time" is a tilted line for another. There is no universal "now" -- only each observer's own perspective on time.
      </p>

      <DiagramMinkowski />

      <Table2 rows={[
        ['Worldline', 'The path an object traces through spacetime (x vs ct)\nVertical = at rest, tilted = moving, 45 deg = speed of light'],
        ['Proper time (tau)', 'Time measured by a clock carried along a worldline\nSlower for fast-moving observers -- shown by tick marks on the worldline'],
        ['Spacetime interval', "ds^2 = -c^2 dt^2 + dx^2 + dy^2 + dz^2\nInvariant -- all observers agree on it even when they disagree on space and time separately"],
        ['Simultaneity slice', "A horizontal line = one observer's 'now'\nTilted for a moving observer -- they disagree on what is 'happening at the same time'"],
        ['Event', 'A single point in spacetime -- a place AND a moment\nAll observers agree an event happened; they just disagree on when and where'],
      ]} />

      <h2>The Light Cone</h2>
      <p>
        At any event in spacetime, draw lines at 45 degrees in both the future and past directions -- this is the <em>light cone</em>. It divides spacetime into three zones. The interior of the future cone contains everything you can influence. The interior of the past cone contains everything that could have influenced you. Everything outside -- the <em>spacelike region</em> -- is causally disconnected from you entirely.
      </p>
      <p>
        This is why <em>nothing can travel faster than light</em>. A worldline tilted beyond 45 degrees would exit the light cone and break causality -- it would arrive before it departed in some observer's frame, which is physically forbidden.
      </p>

      <DiagramLightCone />

      <Table2 rows={[
        ['Speed of light (c)', 'c = 299,792,458 m/s -- exact by definition\nThe same for all observers regardless of their own motion -- the foundational postulate of SR'],
        ['Causal structure', 'Only events within your past light cone can have caused things at your location\nOnly events in your future light cone can be affected by you'],
        ['Spacelike separation', '|Delta x| > c|Delta t| -- outside the light cone\nDifferent observers disagree on which of two spacelike events happened first'],
        ['Timelike separation', '|Delta x| < c|Delta t| -- inside the light cone\nAll observers agree on the time-ordering of these two events'],
        ['Lightlike separation', 'Exactly on the cone surface: |Delta x| = c|Delta t|\nOnly a photon can connect these two events; the spacetime interval is zero'],
      ]} />

      <h2>Time Dilation and Length Contraction</h2>
      <p>
        Two of the most striking predictions of Special Relativity -- both confirmed experimentally many times -- are that <em>moving clocks tick slower</em> and <em>moving rulers are shorter</em>. These are not illusions. They follow directly from the fact that the speed of light is the same for all observers.
      </p>
      <p>
        The factor by which time slows is the <em>Lorentz factor</em> (gamma). At everyday speeds gamma is essentially 1 -- imperceptible. At 87% of the speed of light, gamma = 2: a clock ticks at half speed. At 99.5%c, gamma = 10. This has been confirmed in particle accelerators, with muons from cosmic rays, and with atomic clocks on aircraft.
      </p>

      <DiagramTimeDilation />

      <Table2 rows={[
        ['Time dilation', "t' = gamma * t\nA moving clock runs slow by factor gamma relative to a stationary observer"],
        ['Length contraction', "L' = L / gamma\nA moving ruler is shorter along the direction of motion by factor gamma"],
        ['Lorentz factor', 'gamma = 1 / sqrt(1 - v^2/c^2)\nAt v=0: gamma=1 (no effect). As v approaches c: gamma approaches infinity'],
        ['Cosmic ray muons', 'Muons are created 15 km up and should decay before reaching Earth\nBut their time is dilated by gamma~10 -- they arrive intact. Confirmed every day.'],
        ['GPS satellites', 'Move at ~14,000 km/h: SR slows clocks by 7 microseconds/day\nIn weaker gravity: GR speeds clocks by 45 microseconds/day\nNet correction: +38 microseconds/day -- without it GPS fails within minutes'],
      ]} />

      <h2>Curved Spacetime -- General Relativity</h2>
      <p>
        In Special Relativity, spacetime is flat -- the grid is uniform everywhere. In <em>General Relativity</em>, mass and energy curve spacetime. A planet does not orbit the Sun because the Sun pulls it with a force. It follows the <em>straightest possible path</em> (a geodesic) through spacetime that is curved by the Sun's mass. What looks like a curved orbit in 3D space is actually a straight line through curved 4D spacetime.
      </p>
      <p>
        Light is also deflected by gravity -- not because photons have mass, but because the spacetime through which they travel is curved. This was confirmed by Arthur Eddington's 1919 solar eclipse observation, and is now routinely used in gravitational lensing astronomy.
      </p>

      <Table2 rows={[
        ["Einstein's field equations", 'G_{mu nu} = 8*pi*G/c^4 * T_{mu nu}\n"Matter tells spacetime how to curve; curvature tells matter how to move" -- J.A. Wheeler'],
        ['Geodesic', 'The straightest possible path through curved spacetime\nFree-fall orbits, and the path of light are all geodesics -- no force required'],
        ['Gravitational time dilation', 'Clocks tick slower in stronger gravity fields\nConfirmed: clocks at sea level tick slower than clocks on mountaintops'],
        ['Gravitational waves', 'Accelerating masses ripple spacetime -- first detected by LIGO in 2015\nTwo merging black holes distorted space by 1/1000th the width of a proton'],
        ['Black holes', 'Mass so dense that escape velocity exceeds c -- nothing exits the event horizon\nSpacetime curves so severely that all worldlines inside point toward the singularity'],
        ['Gravitational lensing', 'Mass bends light paths -- distant galaxies appear distorted or multiplied\nUsed to map dark matter across the universe'],
      ]} />

      <h2>The Twin Paradox</h2>
      <p>
        Twin A stays on Earth. Twin B travels to a distant star at near-light speed and returns. When they reunite, <em>B is genuinely younger than A</em>. This seems paradoxical -- if motion is relative, couldn't B say A was the one moving? The resolution is that the situation is <strong>not symmetric</strong>: B had to <em>accelerate to turn around</em>. Only B changed inertial frames. The asymmetry is real and absolute.
      </p>
      <p>
        In the spacetime diagram, the reason is purely geometric: <em>A's worldline is longer through spacetime</em> than B's. More spacetime path length (timelike) means more proper time elapsed. B took a geometric shortcut -- just as a straight road is shorter than a detoured road.
      </p>

      <Table2 rows={[
        ['Why B ages less', "B's worldline is geometrically shorter through spacetime\nThe proper time (spacetime interval) along B's path is smaller"],
        ['The asymmetry', 'B had to accelerate -- fire rockets, change inertial frame\nA never accelerated; that is what breaks the symmetry'],
        ['Spacetime geometry', "A's straight vertical worldline has more proper length\nB's bent path is like a detour that accumulates less proper time"],
        ['Real-world version', 'Fast muons in accelerators live longer than stationary muons\nAstronauts on ISS age ~0.007 seconds less per 6-month mission'],
        ['No paradox', "Completely resolved by the spacetime diagram -- B's worldline\nis simply shorter, just as a detour is longer on a road map"],
      ]} />

      <InfoBox title="Key Formulae" items={[
        'Lorentz factor: gamma = 1 / sqrt(1 - v^2/c^2)',
        'Time dilation: t\' = gamma * t  (moving clock runs slow)',
        'Length contraction: L\' = L / gamma  (moving ruler is shorter)',
        'Spacetime interval: ds^2 = -c^2 dt^2 + dx^2 + dy^2 + dz^2  (invariant for all observers)',
        'Relativistic energy: E = gamma * m * c^2  (at rest: E = m * c^2)',
        'Relativistic momentum: p = gamma * m * v',
        'Gravitational time dilation: dt\' = dt * sqrt(1 - 2GM / (r*c^2))',
        'Einstein\'s field equations: G_{mu nu} = (8 * pi * G / c^4) * T_{mu nu}',
      ]} />
    </div>
  );
}

// -- Canvas renderers ----------------------------------------------
function gridLine(ctx, x1, y1, x2, y2, color, width, dash) {
  if (width === undefined) width = 1;
  if (dash === undefined) dash = [];
  ctx.save();
  ctx.strokeStyle = color;
  ctx.lineWidth = width;
  ctx.setLineDash(dash);
  ctx.beginPath();
  ctx.moveTo(x1, y1);
  ctx.lineTo(x2, y2);
  ctx.stroke();
  ctx.restore();
}

function lbl(ctx, text, x, y, color, size) {
  if (color === undefined) color = '#5a7a9a';
  if (size === undefined) size = 10;
  ctx.save();
  ctx.fillStyle = color;
  ctx.font = size + "px 'Space Mono', monospace";
  ctx.textAlign = 'left';
  ctx.fillText(text, x, y);
  ctx.restore();
}

function lerp(a, b, t) { return a + (b - a) * t; }

function roundRect(ctx, x, y, w, h, r) {
  ctx.beginPath();
  ctx.moveTo(x + r, y);
  ctx.lineTo(x + w - r, y);
  ctx.arcTo(x + w, y, x + w, y + r, r);
  ctx.lineTo(x + w, y + h - r);
  ctx.arcTo(x + w, y + h, x + w - r, y + h, r);
  ctx.lineTo(x + r, y + h);
  ctx.arcTo(x, y + h, x, y + h - r, r);
  ctx.lineTo(x, y + r);
  ctx.arcTo(x, y, x + r, y, r);
  ctx.closePath();
}

function drawDiagram(ctx, W, H, velocity, properTime) {
  const CX = W / 2;
  const CY = H * 0.55;
  ctx.clearRect(0, 0, W, H);
  const bg = ctx.createRadialGradient(CX, CY, 0, CX, CY, W * 0.7);
  bg.addColorStop(0, '#060d1c');
  bg.addColorStop(1, '#03060e');
  ctx.fillStyle = bg;
  ctx.fillRect(0, 0, W, H);
  const step = Math.min(W, H) * 0.064;
  for (let x = CX % step; x < W; x += step) gridLine(ctx, x, 0, x, H, 'rgba(13,26,50,0.7)');
  for (let y = CY % step; y < H; y += step) gridLine(ctx, 0, y, W, y, 'rgba(13,26,50,0.7)');
  gridLine(ctx, CX, H * 0.05, CX, H * 0.95, 'rgba(91,200,250,0.35)', 1.5);
  lbl(ctx, 'ct (time)', CX + 8, H * 0.1, '#5bc8fa', 11);
  ctx.save(); ctx.fillStyle = '#5bc8fa';
  ctx.beginPath(); ctx.moveTo(CX, H*0.05); ctx.lineTo(CX-5, H*0.08); ctx.lineTo(CX+5, H*0.08); ctx.closePath(); ctx.fill(); ctx.restore();
  gridLine(ctx, W * 0.05, CY, W * 0.95, CY, 'rgba(91,200,250,0.25)', 1.5);
  lbl(ctx, 'x (space)', W * 0.88, CY - 8, '#5bc8fa', 11);
  ctx.save(); ctx.fillStyle = '#5bc8fa';
  ctx.beginPath(); ctx.moveTo(W*0.95, CY); ctx.lineTo(W*0.93, CY-5); ctx.lineTo(W*0.93, CY+5); ctx.closePath(); ctx.fill(); ctx.restore();
  const coneH = Math.min(CY * 0.92, (W - CX) * 0.92);
  ctx.save();
  ctx.beginPath(); ctx.moveTo(CX, CY); ctx.lineTo(CX+coneH, CY-coneH); ctx.lineTo(CX-coneH, CY-coneH); ctx.closePath();
  const fcg = ctx.createLinearGradient(CX, CY, CX, CY-coneH);
  fcg.addColorStop(0, 'rgba(255,200,50,0.18)'); fcg.addColorStop(1, 'rgba(255,200,50,0.03)');
  ctx.fillStyle = fcg; ctx.fill(); ctx.restore();
  const coneD = Math.min((H - CY) * 0.92, (W - CX) * 0.92);
  ctx.save();
  ctx.beginPath(); ctx.moveTo(CX, CY); ctx.lineTo(CX+coneD, CY+coneD); ctx.lineTo(CX-coneD, CY+coneD); ctx.closePath();
  const pcg = ctx.createLinearGradient(CX, CY, CX, CY+coneD);
  pcg.addColorStop(0, 'rgba(255,80,30,0.14)'); pcg.addColorStop(1, 'rgba(255,80,30,0.02)');
  ctx.fillStyle = pcg; ctx.fill(); ctx.restore();
  const lc = Math.min(coneH, coneD);
  gridLine(ctx, CX, CY-lc, CX+lc, CY, '#ffe040', 1.5, [6, 4]);
  gridLine(ctx, CX, CY-lc, CX-lc, CY, '#ffe040', 1.5, [6, 4]);
  gridLine(ctx, CX, CY+lc, CX+lc, CY, '#ffe040', 1, [4, 4]);
  gridLine(ctx, CX, CY+lc, CX-lc, CY, '#ffe040', 1, [4, 4]);
  lbl(ctx, 'FUTURE', CX+8, CY-coneH*0.5, 'rgba(255,200,50,0.45)', 9);
  lbl(ctx, 'PAST', CX+8, CY+coneD*0.5, 'rgba(255,80,30,0.4)', 9);
  lbl(ctx, 'ELSEWHERE', CX+lc*0.22, CY-6, 'rgba(91,200,250,0.3)', 8);
  lbl(ctx, 'ELSEWHERE', CX-lc*0.72, CY-6, 'rgba(91,200,250,0.3)', 8);
  lbl(ctx, 'light (v=c)', CX+lc*0.33, CY-lc*0.42, '#ffe04080', 9);
  const wlLen = CY * 0.9;
  ctx.save(); ctx.strokeStyle = '#7eb8f7'; ctx.lineWidth = 2.5; ctx.shadowColor = '#7eb8f750'; ctx.shadowBlur = 8;
  ctx.beginPath(); ctx.moveTo(CX, CY+wlLen*0.12); ctx.lineTo(CX, CY-wlLen*properTime); ctx.stroke(); ctx.restore();
  lbl(ctx, 'A (at rest)', CX+6, CY-wlLen*properTime+4, '#7eb8f7', 10);
  const ticks = 8;
  for (let i = 0; i <= ticks*properTime; i++) {
    const ty = CY - (wlLen*properTime/(ticks*properTime))*i;
    gridLine(ctx, CX-4, ty, CX+4, ty, '#7eb8f760', 1.5);
  }
  const angle = Math.atan(velocity);
  const bLen = wlLen*properTime*1.05;
  const bDx = Math.sin(angle)*bLen;
  const bDct = Math.cos(angle)*bLen;
  ctx.save(); ctx.strokeStyle = '#f78e7e'; ctx.lineWidth = 2.5; ctx.shadowColor = '#f78e7e50'; ctx.shadowBlur = 8; ctx.setLineDash([8,5]);
  ctx.beginPath(); ctx.moveTo(CX-bDx*0.1, CY+bDct*0.1); ctx.lineTo(CX+bDx, CY-bDct); ctx.stroke(); ctx.restore();
  lbl(ctx, 'B  (v='+velocity.toFixed(2)+'c)', CX+bDx+6, CY-bDct, '#f78e7e', 10);
  const gamma = 1/Math.sqrt(1-velocity*velocity);
  const bTicksN = Math.max(1, Math.round(ticks*properTime/gamma));
  for (let i = 0; i <= bTicksN; i++) {
    const t = i/bTicksN;
    const tx = (CX-bDx*0.1)+(bDx+bDx*0.1)*t*0.95;
    const ty = (CY+bDct*0.1)+(-bDct-bDct*0.1)*t*0.95;
    const px2 = Math.cos(angle+Math.PI/2)*4;
    const py2 = -Math.sin(angle+Math.PI/2)*4;
    gridLine(ctx, tx-px2, ty-py2, tx+px2, ty+py2, '#f78e7e80', 1.5);
  }
  const aEventY = CY-wlLen*properTime;
  const sliceLen = Math.min(CX*0.82, (W-CX)*0.82);
  ctx.save(); ctx.strokeStyle='rgba(100,200,255,0.35)'; ctx.lineWidth=1.5; ctx.setLineDash([12,6]);
  ctx.beginPath(); ctx.moveTo(CX-sliceLen, aEventY); ctx.lineTo(CX+sliceLen, aEventY); ctx.stroke(); ctx.restore();
  lbl(ctx, "A's 'now'", CX+sliceLen-46, aEventY-5, 'rgba(100,200,255,0.6)', 9);
  const bSliceSlope = velocity;
  const bEventX = CX+bDx*properTime;
  const bEventY = CY-bDct*properTime;
  const slDx = sliceLen, slDct = sliceLen*bSliceSlope;
  ctx.save(); ctx.strokeStyle='rgba(255,160,80,0.45)'; ctx.lineWidth=1.5; ctx.setLineDash([12,6]);
  ctx.beginPath(); ctx.moveTo(bEventX-slDx, bEventY+slDct); ctx.lineTo(bEventX+slDx, bEventY-slDct); ctx.stroke(); ctx.restore();
  lbl(ctx, "B's 'now'", bEventX+slDx-46, bEventY-slDct-5, 'rgba(255,160,80,0.7)', 9);
  const bNowAtCx = bEventY-bSliceSlope*(bEventX-CX);
  if (Math.abs(bNowAtCx-aEventY) > 4) {
    ctx.save(); ctx.strokeStyle='rgba(255,220,100,0.5)'; ctx.lineWidth=1; ctx.setLineDash([3,3]);
    ctx.beginPath(); ctx.moveTo(CX+18, aEventY); ctx.lineTo(CX+18, bNowAtCx); ctx.stroke();
    ctx.fillStyle='rgba(255,220,100,0.7)'; ctx.font="8px 'Space Mono',monospace";
    ctx.fillText('Delta t', CX+22, (aEventY+bNowAtCx)/2+3); ctx.restore();
  }
  [{x:CX,y:CY,c:'#fff',r:4},{x:CX,y:aEventY,c:'#7eb8f7',r:5},{x:bEventX,y:bEventY,c:'#f78e7e',r:5}].forEach(function(d){
    ctx.save(); ctx.fillStyle=d.c; ctx.shadowColor=d.c+'80'; ctx.shadowBlur=10;
    ctx.beginPath(); ctx.arc(d.x, d.y, d.r, 0, Math.PI*2); ctx.fill(); ctx.restore();
  });
  lbl(ctx, 'Event (0,0)', CX+7, CY+4, '#ffffff60', 9);
  lbl(ctx, 'gamma='+gamma.toFixed(2)+'  tau_B='+(properTime*10/gamma).toFixed(2)+'  tau_A='+(properTime*10).toFixed(2), 16, H-16, 'rgba(91,200,250,0.8)', 10);
  ctx.save(); ctx.fillStyle='rgba(200,220,255,0.15)'; ctx.font="italic 300 13px 'Crimson Pro',serif";
  ctx.fillText('Minkowski Spacetime Diagram -- Special Relativity', 16, 24); ctx.restore();
}

function drawLightCone(ctx, W, H, animFrame) {
  const CX = W/2, CY = H*0.55;
  ctx.clearRect(0,0,W,H);
  const bg = ctx.createRadialGradient(CX,CY,0,CX,CY,W*0.7);
  bg.addColorStop(0,'#050c1a'); bg.addColorStop(1,'#020509');
  ctx.fillStyle=bg; ctx.fillRect(0,0,W,H);
  const now = animFrame*0.01;
  const R = Math.min(W,H)*0.32*0.55;
  const coneH = R*1.2;
  function drawRing(y, radius, alpha, r, g, b) {
    ctx.save(); ctx.strokeStyle='rgba('+r+','+g+','+b+','+alpha+')';
    ctx.lineWidth=1; ctx.beginPath(); ctx.ellipse(CX, y, radius, radius*0.28, 0, 0, Math.PI*2); ctx.stroke(); ctx.restore();
  }
  for (let i=0; i<=14; i++) {
    const t=i/14;
    drawRing(CY-coneH*t, R*t, 0.08+t*0.25, 255, 200, 50);
    drawRing(CY+coneH*t, R*t, 0.06+t*0.2,  255, 80,  30);
  }
  for (let i=0; i<16; i++) {
    const theta = (i/16)*Math.PI*2+now;
    gridLine(ctx, CX, CY, CX+R*Math.cos(theta), CY-coneH, 'rgba(255,200,50,0.35)', 1);
    gridLine(ctx, CX, CY, CX+R*Math.cos(theta), CY+coneH, 'rgba(255,80,30,0.25)', 1);
  }
  ctx.save(); ctx.beginPath(); ctx.ellipse(CX, CY, R*1.05, R*1.05*0.3, 0, 0, Math.PI*2);
  ctx.strokeStyle='rgba(91,200,250,0.4)'; ctx.lineWidth=1.5; ctx.setLineDash([8,4]); ctx.stroke();
  const elg=ctx.createRadialGradient(CX,CY,0,CX,CY,R);
  elg.addColorStop(0,'rgba(91,200,250,0.08)'); elg.addColorStop(1,'rgba(91,200,250,0.01)');
  ctx.fillStyle=elg; ctx.fill(); ctx.restore();
  lbl(ctx,'3D Space ("now")',CX-R-58,CY+4,'rgba(91,200,250,0.6)',10);
  gridLine(ctx,CX,CY-coneH*1.1,CX,CY+coneH*1.1,'rgba(91,200,250,0.3)',1.5);
  lbl(ctx,'time ->',CX+6,CY-coneH*1.05,'#5bc8fa',10);
  ctx.save(); ctx.fillStyle='#fff'; ctx.shadowColor='#fff'; ctx.shadowBlur=16;
  ctx.beginPath(); ctx.arc(CX,CY,5,0,Math.PI*2); ctx.fill(); ctx.restore();
  lbl(ctx,'"Here and Now"',CX+8,CY-8,'#ffffffa0',10);
  ctx.save(); ctx.fillStyle='rgba(255,200,50,0.7)'; ctx.font="bold 11px 'Space Mono',monospace";
  ctx.fillText('FUTURE LIGHT CONE',CX+R*0.3,CY-coneH*0.65); ctx.restore();
  ctx.save(); ctx.fillStyle='rgba(255,80,30,0.55)'; ctx.font="bold 11px 'Space Mono',monospace";
  ctx.fillText('PAST LIGHT CONE',CX+R*0.3,CY+coneH*0.7); ctx.restore();
  ctx.save(); ctx.fillStyle='rgba(200,220,255,0.15)'; ctx.font="italic 300 13px 'Crimson Pro',serif";
  ctx.fillText('3D Light Cone -- Causal Structure of Spacetime',16,24); ctx.restore();
}

function drawGeodesic(ctx, W, H, curvature, animFrame) {
  const CX=W/2, CY=H/2;
  ctx.clearRect(0,0,W,H);
  const bg=ctx.createRadialGradient(CX,CY,0,CX,CY,W*0.7);
  bg.addColorStop(0,'#060f1a'); bg.addColorStop(1,'#020407');
  ctx.fillStyle=bg; ctx.fillRect(0,0,W,H);
  const now=animFrame*0.005;
  const k=curvature;
  const cols=20, rows=14;
  const gx0=W*0.05, gy0=H*0.12, gw=W*0.9, gh=H*0.7;
  const massX=0.5, massY=0.5;
  function deform(nx, ny) {
    const relX=nx-massX, relY=ny-massY;
    const dist=Math.sqrt(relX*relX+relY*relY)+0.01;
    const pull=k*0.25/(dist*dist+0.04);
    return {sx:gx0+nx*gw, sy:gy0+ny*gh+pull*gh*(massY-ny)*2};
  }
  for (let r=0; r<=rows; r++) {
    ctx.beginPath();
    for (let c=0; c<=cols; c++) { const p=deform(c/cols,r/rows); c===0?ctx.moveTo(p.sx,p.sy):ctx.lineTo(p.sx,p.sy); }
    ctx.strokeStyle='rgba(30,90,160,0.35)'; ctx.lineWidth=1; ctx.stroke();
  }
  for (let c=0; c<=cols; c++) {
    ctx.beginPath();
    for (let r=0; r<=rows; r++) { const p=deform(c/cols,r/rows); r===0?ctx.moveTo(p.sx,p.sy):ctx.lineTo(p.sx,p.sy); }
    ctx.strokeStyle='rgba(20,70,130,0.3)'; ctx.lineWidth=1; ctx.stroke();
  }
  const mc=deform(massX,massY);
  const massRadius=28+k*20;
  const mg=ctx.createRadialGradient(mc.sx,mc.sy,0,mc.sx,mc.sy,massRadius*2);
  mg.addColorStop(0,'rgba(255,200,80,0.9)'); mg.addColorStop(0.3,'rgba(255,140,40,0.6)'); mg.addColorStop(1,'rgba(255,80,0,0)');
  ctx.fillStyle=mg; ctx.beginPath(); ctx.arc(mc.sx,mc.sy,massRadius*2,0,Math.PI*2); ctx.fill();
  ctx.fillStyle='#ffe080'; ctx.beginPath(); ctx.arc(mc.sx,mc.sy,massRadius*0.4,0,Math.PI*2); ctx.fill();
  const orbitRadius=0.22-k*0.06;
  const orbitSpeed=0.8+k*1.5;
  const ppx=massX+orbitRadius*Math.cos(now*orbitSpeed);
  const ppy=massY+orbitRadius*Math.sin(now*orbitSpeed)*0.55;
  const pp=deform(ppx,ppy);
  ctx.beginPath();
  for (let i=0; i<60; i++) {
    const t2=now*orbitSpeed-(i/60)*Math.PI*2;
    const trp=deform(massX+orbitRadius*Math.cos(t2), massY+orbitRadius*Math.sin(t2)*0.55);
    i===0?ctx.moveTo(trp.sx,trp.sy):ctx.lineTo(trp.sx,trp.sy);
  }
  ctx.strokeStyle='rgba(126,184,247,0.5)'; ctx.lineWidth=1.5; ctx.stroke();
  ctx.fillStyle='#7eb8f7'; ctx.shadowColor='#7eb8f7'; ctx.shadowBlur=12;
  ctx.beginPath(); ctx.arc(pp.sx,pp.sy,5,0,Math.PI*2); ctx.fill(); ctx.shadowBlur=0;
  ctx.beginPath();
  for (let t2=0; t2<=1; t2+=0.02) {
    const nx=lerp(0.05,0.95,t2);
    const dist=Math.abs(nx-massX);
    const deflect=k*0.07/(dist*dist+0.02);
    const p=deform(nx, massY-0.22+deflect);
    t2===0?ctx.moveTo(p.sx,p.sy):ctx.lineTo(p.sx,p.sy);
  }
  ctx.strokeStyle='rgba(255,220,60,0.65)'; ctx.lineWidth=1.5; ctx.setLineDash([6,4]); ctx.stroke(); ctx.setLineDash([]);
  lbl(ctx,'Mass (curves spacetime)',mc.sx+massRadius*0.8,mc.sy-massRadius*0.6,'rgba(255,200,80,0.7)',10);
  lbl(ctx,'Geodesic (orbit)',pp.sx+8,pp.sy-8,'rgba(126,184,247,0.8)',10);
  const lp=deform(0.7,massY-0.15);
  lbl(ctx,'Light deflected by gravity',lp.sx,lp.sy-8,'rgba(255,220,60,0.65)',9);
  lbl(ctx,'curvature k='+k.toFixed(2)+'  (use curvature slider)',16,H-16,'rgba(180,210,255,0.5)',10);
  ctx.save(); ctx.fillStyle='rgba(200,220,255,0.15)'; ctx.font="italic 300 13px 'Crimson Pro',serif";
  ctx.fillText('Curved Spacetime -- General Relativity',16,24); ctx.restore();
}

function drawTwin(ctx, W, H, velocity) {
  ctx.clearRect(0,0,W,H);
  const bg=ctx.createRadialGradient(W/2,H*0.3,0,W/2,H/2,W*0.6);
  bg.addColorStop(0,'#060d1c'); bg.addColorStop(1,'#020408');
  ctx.fillStyle=bg; ctx.fillRect(0,0,W,H);
  const ox=W*0.2, oy=H*0.82, tw=W*0.65, th=H*0.65;
  gridLine(ctx,ox,oy,ox,oy-th,'rgba(91,200,250,0.3)',1.5);
  gridLine(ctx,ox,oy,ox+tw,oy,'rgba(91,200,250,0.2)',1.5);
  lbl(ctx,'ct',ox-20,oy-th+10,'#5bc8fa',11);
  lbl(ctx,'x',ox+tw+8,oy+4,'#5bc8fa',11);
  const gamma=1/Math.sqrt(1-velocity*velocity);
  const ax=ox, aTop=oy-th;
  gridLine(ctx,ax,oy,ax,aTop,'#7eb8f7',2.5);
  lbl(ctx,'A (stays)',ax-66,aTop+4,'#7eb8f7',10);
  const turnX=ox+tw*0.35*velocity, turnY=oy-th*0.5;
  ctx.save(); ctx.strokeStyle='#f78e7e'; ctx.lineWidth=2.5; ctx.setLineDash([7,4]);
  ctx.beginPath(); ctx.moveTo(ox,oy); ctx.lineTo(turnX,turnY); ctx.lineTo(ax,aTop); ctx.stroke(); ctx.restore();
  lbl(ctx,'B (travels)',turnX+8,turnY-4,'#f78e7e',10);
  const tauA=10.0, tauB=tauA/gamma;
  const nTicks=10;
  for (let i=0; i<=nTicks; i++) {
    const ty=oy-th*(i/nTicks);
    gridLine(ctx,ax-5,ty,ax+5,ty,'#7eb8f760',1.5);
  }
  const bTicksN=Math.max(1, Math.round(nTicks/gamma));
  for (let i=0; i<=bTicksN; i++) {
    const t=i/bTicksN;
    var bpx, bpy;
    if (t<0.5) { const t2=t*2; bpx=lerp(ox,turnX,t2); bpy=lerp(oy,turnY,t2); }
    else { const t2=(t-0.5)*2; bpx=lerp(turnX,ax,t2); bpy=lerp(turnY,aTop,t2); }
    const ang=t<0.5?Math.atan2(turnX-ox,oy-turnY):Math.atan2(ax-turnX,turnY-aTop);
    gridLine(ctx,bpx-Math.cos(ang)*4,bpy+Math.sin(ang)*4,bpx+Math.cos(ang)*4,bpy-Math.sin(ang)*4,'#f78e7e80',1.5);
  }
  const bx2=ox+tw*0.6, by2=H*0.15;
  ctx.save(); ctx.fillStyle='rgba(8,20,40,0.85)'; ctx.strokeStyle='rgba(91,200,250,0.2)'; ctx.lineWidth=1;
  roundRect(ctx,bx2,by2,200,116,6); ctx.fill(); ctx.stroke(); ctx.restore();
  ctx.save();
  ctx.fillStyle='#5bc8fa'; ctx.font="9px 'Space Mono',monospace"; ctx.fillText('TWIN PARADOX RESULT',bx2+12,by2+18);
  ctx.fillStyle='#c8d8ee'; ctx.font="10px 'Space Mono',monospace"; ctx.fillText('A ages:  tau_A = '+tauA.toFixed(1)+' years',bx2+12,by2+40);
  ctx.fillStyle='#f78e7e'; ctx.fillText('B ages:  tau_B = '+tauB.toFixed(2)+' years',bx2+12,by2+58);
  ctx.fillStyle='rgba(180,220,180,0.7)'; ctx.fillText('Age diff: '+(tauA-tauB).toFixed(2)+' years',bx2+12,by2+76);
  ctx.fillStyle='#6a8aaa'; ctx.font="8px 'Space Mono',monospace"; ctx.fillText('v='+velocity.toFixed(2)+'c   gamma='+gamma.toFixed(3),bx2+12,by2+96);
  ctx.restore();
  ctx.save(); ctx.fillStyle='#f7c87e'; ctx.shadowColor='#f7c87e'; ctx.shadowBlur=10;
  ctx.beginPath(); ctx.arc(turnX,turnY,5,0,Math.PI*2); ctx.fill(); ctx.shadowBlur=0;
  ctx.fillStyle='rgba(247,200,126,0.7)'; ctx.font="9px 'Space Mono',monospace"; ctx.fillText('Turnaround',turnX+8,turnY+4); ctx.restore();
  [[ox,oy,'#fff'],[ax,aTop,'#aaf']].forEach(function(d){
    ctx.save(); ctx.fillStyle=d[2]; ctx.shadowColor=d[2]; ctx.shadowBlur=8;
    ctx.beginPath(); ctx.arc(d[0],d[1],4,0,Math.PI*2); ctx.fill(); ctx.restore();
  });
  ctx.save(); ctx.fillStyle='rgba(200,220,255,0.15)'; ctx.font="italic 300 13px 'Crimson Pro',serif";
  ctx.fillText("Twin Paradox -- B's shorter worldline path = less aging",16,24); ctx.restore();
  lbl(ctx,'Fewer tick marks on B = less proper time = B is younger at reunion',16,H-16,'rgba(180,210,255,0.45)',10);
}

// -- Interactive View ----------------------------------------------
function InteractiveView() {
  const canvasRef = useRef(null);
  const animIdRef = useRef(null);
  const animFrameRef = useRef(0);
  const stateRef = useRef({ view: 'diagram', velocity: 0.6, properTime: 0.5, curvature: 0.3 });
  const [view, setViewState] = useState('diagram');
  const [velocity, setVelocity] = useState(0.6);
  const [properTime, setProperTime] = useState(0.5);
  const [curvature, setCurvature] = useState(0.3);
  const [activeTab, setActiveTab] = useState('view');

  useEffect(() => { stateRef.current = { view, velocity, properTime, curvature }; }, [view, velocity, properTime, curvature]);

  const draw = useCallback(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    const W = canvas.width, H = canvas.height;
    const s = stateRef.current;
    if (s.view === 'diagram') drawDiagram(ctx, W, H, s.velocity, s.properTime);
    else if (s.view === 'lightcone') drawLightCone(ctx, W, H, animFrameRef.current);
    else if (s.view === 'geodesic') drawGeodesic(ctx, W, H, s.curvature, animFrameRef.current);
    else if (s.view === 'twin') drawTwin(ctx, W, H, s.velocity);
  }, []);

  const startAnim = useCallback(() => {
    const loop = () => { animFrameRef.current++; draw(); animIdRef.current = requestAnimationFrame(loop); };
    if (!animIdRef.current) animIdRef.current = requestAnimationFrame(loop);
  }, [draw]);

  const stopAnim = useCallback(() => {
    if (animIdRef.current) { cancelAnimationFrame(animIdRef.current); animIdRef.current = null; }
  }, []);

  useEffect(() => {
    const canvas = canvasRef.current;
    const area = canvas.parentElement;
    const ro = new ResizeObserver(() => { canvas.width = area.clientWidth; canvas.height = area.clientHeight; draw(); });
    ro.observe(area);
    canvas.width = area.clientWidth;
    canvas.height = area.clientHeight;
    draw();
    return () => ro.disconnect();
  }, [draw]);

  useEffect(() => {
    const needsAnim = view === 'lightcone' || view === 'geodesic';
    if (needsAnim) startAnim();
    else { stopAnim(); draw(); }
    return stopAnim;
  }, [view, startAnim, stopAnim, draw]);

  useEffect(() => {
    if (view === 'diagram' || view === 'twin') draw();
  }, [velocity, properTime, curvature, view, draw]);

  const setView = (v) => { setViewState(v); stateRef.current.view = v; };
  const tabs = ['view', 'controls', 'physics', 'compare'];

  return (
    <div className="st-layout">
      <div className="st-canvas-area"><canvas ref={canvasRef} /></div>
      <div className="st-sidebar">
        <div className="st-tabs">
          {tabs.map(t => (
            <button key={t} className={'st-tab' + (activeTab === t ? ' active' : '')} onClick={() => setActiveTab(t)}>
              {t === 'compare' ? 'Newton vs' : t.charAt(0).toUpperCase() + t.slice(1)}
            </button>
          ))}
        </div>
        {activeTab === 'view' && (
          <div className="st-tab-content">
            <div className="st-panel-title">Display Mode</div>
            <div className="st-view-toggle">
              {[['diagram','Spacetime Diagram'],['lightcone','Light Cone'],['geodesic','Curved Spacetime'],['twin','Twin Paradox']].map(([id, label]) => (
                <button key={id} className={'st-view-btn' + (view === id ? ' active' : '')} onClick={() => setView(id)}>{label}</button>
              ))}
            </div>
            <div style={{ marginTop: 16 }}>
              <div className="st-panel-title">Legend</div>
              {[
                [<div className="st-swatch" style={{ background: '#7eb8f7' }} />, 'Observer A worldline'],
                [<div className="st-swatch-dashed" />, 'Observer B worldline'],
                [<div className="st-swatch" style={{ background: '#ffe040' }} />, 'Photon / light ray (45 deg)'],
                [<div className="st-swatch" style={{ background: 'rgba(100,200,255,0.5)' }} />, "Simultaneity slice (A's now)"],
                [<div className="st-swatch" style={{ background: 'rgba(255,160,80,0.5)' }} />, "Simultaneity slice (B's now)"],
              ].map(([swatch, text], i) => (
                <div key={i} className="st-key-item">{swatch}{text}</div>
              ))}
            </div>
          </div>
        )}
        {activeTab === 'controls' && (
          <div className="st-tab-content">
            <div className="st-slider-row">
              <div className="st-slider-label"><span>Observer B Velocity</span><span>{velocity.toFixed(2)}c</span></div>
              <input type="range" className="st-slider" min="0" max="95" value={Math.round(velocity * 100)} onChange={e => setVelocity(e.target.value / 100)} />
              <div className="st-insight">Tilts B's worldline. At c, it aligns with the light cone.</div>
            </div>
            <div className="st-slider-row">
              <div className="st-slider-label"><span>Proper Time</span><span>tau = {(properTime * 10).toFixed(1)}</span></div>
              <input type="range" className="st-slider" min="0" max="100" value={Math.round(properTime * 100)} onChange={e => setProperTime(e.target.value / 100)} />
              <div className="st-insight">Advance proper time along each worldline.</div>
            </div>
            <div className="st-slider-row">
              <div className="st-slider-label"><span>Spacetime Curvature</span><span>k = {curvature.toFixed(2)}</span></div>
              <input type="range" className="st-slider" min="0" max="100" value={Math.round(curvature * 100)} onChange={e => setCurvature(e.target.value / 100)} />
              <div className="st-insight">Simulates gravitational mass curving geodesics (GR view).</div>
            </div>
          </div>
        )}
        {activeTab === 'physics' && (
          <div className="st-tab-content">
            <div className="st-panel-title">Key Concepts</div>
            <div className="st-concept">In Einstein's universe, <em>space and time are one fabric</em> &mdash; spacetime. You don't move through space "over time". You trace a <em>worldline</em> through 4D spacetime.</div>
            <div className="st-formula">ds&sup2; = &minus;c&sup2;dt&sup2; + dx&sup2; + dy&sup2; + dz&sup2;</div>
            <div className="st-insight">The spacetime interval ds&sup2; is invariant &mdash; all observers agree on it, even if they disagree on space and time separately.</div>
            <div className="st-formula">&gamma; = 1/&radic;(1 &minus; v&sup2;/c&sup2;)</div>
            <div className="st-insight">The Lorentz factor: as v &rarr; c, time dilates and lengths contract. There is no absolute "now".</div>
            <div className="st-formula">G<sub>&mu;&nu;</sub> = 8&pi;G T<sub>&mu;&nu;</sub>/c&sup4;</div>
            <div className="st-insight">Einstein's field equations: mass-energy curves spacetime; curvature tells matter how to move.</div>
            <div className="st-concept">The <em>light cone</em> is fundamental &mdash; it defines what can causally influence what. No worldline can exceed 45&deg; from vertical.</div>
          </div>
        )}
        {activeTab === 'compare' && (
          <div className="st-tab-content">
            <div className="st-panel-title">Newton vs Einstein</div>
            <div className="st-compare-grid">
              <div className="st-nc-newton"><strong>Newton</strong>Absolute time flows uniformly for all. Space is a fixed container. Events have a single universal "now".</div>
              <div className="st-nc-einstein"><strong>Einstein</strong>Time is relative to the observer. Space and time are unified. There is no universal "now". Simultaneity depends on motion.</div>
            </div>
            <div className="st-insight" style={{ marginTop: 12 }}>In the Newtonian diagram, the cube of space slides along a time axis. In Einstein's model, the "cube" and the "axis" are the same thing &mdash; and they bend.</div>
            <div className="st-concept" style={{ marginTop: 10 }}>The simultaneity slices <em>tilt differently for every observer</em> moving at a different velocity &mdash; there is no shared "now" across space.</div>
          </div>
        )}
      </div>
    </div>
  );
}

// -- Root Component ------------------------------------------------
export default function EinsteinSpacetime() {
  const [page, setPage] = useState('interactive');
  return (
    <>
      <style>{styles}</style>
      <div className="st-root">
        <div className="st-header">
          <div className="st-header-left">
            <h1>Spacetime &mdash; The Einsteinian Universe</h1>
            <span className="subtitle">Special &amp; General Relativity &middot; Interactive Model</span>
          </div>
          <div className="st-page-tabs">
            <button className={'st-page-tab' + (page === 'interactive' ? ' active' : '')} onClick={() => setPage('interactive')}>Interactive</button>
            <button className={'st-page-tab' + (page === 'guide' ? ' active' : '')} onClick={() => setPage('guide')}>Guide</button>
          </div>
        </div>
        {page === 'interactive' ? <InteractiveView /> : <GuidePage />}
      </div>
    </>
  );
}